import FetchBase from '../Api/FetchBase'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { observable, action } from 'mobx'
import { reStructurePermissions } from '../Utils/helpers'
import { COOKIE_STOAGE } from '../Utils/Storage'

export default class SubscriptionStore extends FetchBase {
  @observable allSubscriptionDropdown = []
  @observable usageByOrgId = []
  @observable subPlanId = []
  @observable planName = []
  @observable subscriptionPlanList = []
  @observable updateSubscriptionPlanLoader = false
  @observable subscriptionPlanListLoader = false
  @observable subscriptionKeyList = []
  @observable subscriptionCancelLoading = false
  @observable subscriptionCancelReqDeleteLoader = false
  @observable userUpdateInPlanLoader = false

  @observable generateBraintreeTokenLoader = false
  @observable paymentHistoryOrdering = undefined
  @observable paymentHistoryOrderingBy = undefined
  @observable paymentHistorySearchText = ''
  @observable paymentHistoryFilter = {}
  @observable paymentHistoryPageNo = DEFAULT_PAGE_START
  @observable subscriptionHistoryLoader = false
  @observable subscriptionHistory = []
  @observable paymentHistoryTotal = 0

  @observable orgwizardDetails = []
  @observable orgwizardDetailsforAll = []

  @observable currentPlanDetails = {}
  @observable currentPlanLoader = false
  @observable isPaymentCard = false
  @observable downloadTCLoader = false
  @observable subscriptionOrderSummary = {}
  @observable subscriptionOrderSummaryLoader = false

  @observable activePaymentSubscriptionOrdering = undefined
  @observable activePaymentSubscriptionOrderingBy = undefined
  @observable activePaymentSubscriptionSearchText = ''
  @observable activePaymentSubscriptionFilter = {}
  @observable activePaymentSubscriptionPageNo = DEFAULT_PAGE_START
  @observable activePaymentSubscriptionLoader = false
  @observable activePaymentSubscriptionList = []
  @observable activePaymentSubscriptionTotal = 0

  @observable inActivePaymentSubscriptionOrdering = undefined
  @observable inActivePaymentSubscriptionOrderingBy = undefined
  @observable inActivePaymentSubscriptionSearchText = ''
  @observable inActivePaymentSubscriptionFilter = {}
  @observable inActivePaymentSubscriptionPageNo = DEFAULT_PAGE_START
  @observable inActivePaymentSubscriptionLoader = false
  @observable inActivePaymentSubscriptionList = []
  @observable inActivePaymentSubscriptionTotal = 0

  @action.bound
  geltAllSubscriptionDropdown = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_SUBSCRIPTION_PLAN,
        {},
        signal
      )
      this.allSubscriptionDropdown = response.data || []
      return true
    } catch {
      this.allSubscriptionDropdown = []
      return false
    }
  }

  @action.bound
  getUsageByOrgId = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS?.GET_USAGE_BY_ORG_ID,
        {},
        signal
      )
      if (response.status) {
        this.usageByOrgId = response.data || []
        this.subPlanId = response.data.plan.id || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getPlanslistByOrgId = async () => {
    try {
      this.subscriptionPlanListLoader = true
      let respone = await this.get(API_ENDPOINTS?.GET_SUBSCRIPTION_PLANS_LIST)
      if (respone.status) {
        this.subscriptionPlanList = respone.data
        this.subscriptionKeyList = reStructurePermissions(respone?.data?.[0])
        return [true, respone.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.subscriptionPlanListLoader = false
    }
  }

  @action.bound
  updateSubscriptionPlan = async (values) => {
    try {
      this.updateSubscriptionPlanLoader = true
      let respone = await this.post(API_ENDPOINTS.UPDATE_SUBSCRIPTION_PLAN, {
        ...values,
      })
      if (respone?.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateSubscriptionPlanLoader = false
    }
  }
  @action.bound
  getMyAllCards = async () => {
    try {
      let respone = await this.get(API_ENDPOINTS.GET_ALL_MY_CARDS)
      if (respone?.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setDefaultCard = async (cardToken) => {
    try {
      let response = await this.post(API_ENDPOINTS.SET_DEFAULT_CARD, {
        ...cardToken,
      })

      if (response?.status) {
        this.isPaymentCard = true
        return [true, response?.data]
      }

      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addCard = async (payment) => {
    try {
      let response = await this.post(API_ENDPOINTS.ADD_CARDS, {
        ...payment,
      })

      if (response?.status) {
        this.isPaymentCard = true
        return [true, response?.data]
      }

      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  currentIsCard = async (value) => {
    return (this.isPaymentCard = value)
  }

  @action.bound
  setCurrentSelectedPlan = async (value = undefined) => {
    COOKIE_STOAGE.setItem('currentSelectedPlan', value)
  }

  @action.bound
  generateBraintreeToken = async () => {
    try {
      this.generateBraintreeTokenLoader = true
      let response = await this.get(
        API_ENDPOINTS.GENERATE_CLIENT_TOKEN_BRAINTREE
      )

      if (response?.status) {
        return [true, response?.data]
      }

      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.generateBraintreeTokenLoader = false
    }
  }

  @action.bound
  subscriptionCancel = async (orgId, isRequest) => {
    try {
      this.subscriptionCancelLoading = true
      let response = await this.post(
        isRequest
          ? API_ENDPOINTS?.DELETE_CANCEL_SUBSCRIPTION_REQ
          : API_ENDPOINTS?.CANCEL_SUBSCRIPTION,
        {
          orgId,
        }
      )
      if (response?.status) {
        return [true, response?.message]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.subscriptionCancelLoading = false
    }
  }

  @action.bound
  setUserUpdateInSubscriptionPlan = async (values) => {
    try {
      this.userUpdateInPlanLoader = true
      let respone = await this.post(
        API_ENDPOINTS.UPDATE_USERS_IN_SUBSCRIPTION,
        {
          ...values,
        }
      )
      if (respone?.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.userUpdateInPlanLoader = false
    }
  }

  @action.bound
  setPaymentHistoryOrdering = (value = undefined) => {
    this.paymentHistoryOrdering = value
  }

  @action.bound
  setPaymentHistoryOrderingBy = (value = undefined) => {
    this.paymentHistoryOrderingBy = value
  }

  @action.bound
  setPaymentHistoryFilter = (value = {}) => {
    this.paymentHistoryFilter = value
  }

  @action.bound
  setPaymentHistorySearchText = (value = '') => {
    this.paymentHistorySearchText = value
  }

  @action.bound
  setPaymentHistoryPageNo = (page = DEFAULT_PAGE_START) => {
    this.paymentHistoryPageNo = page
  }

  @action.bound
  getFilterObjectForPaymentHistory = () => {
    let options = {}
    let keys = Object.keys(this.paymentHistoryFilter || {})
    for (let filter of keys) {
      if (this.paymentHistoryFilter[filter]) {
        options[filter] = this.paymentHistoryFilter[filter]
      }
    }
    this.paymentHistorySearchText &&
      (options['search'] = this.paymentHistorySearchText)
    if (this.paymentHistoryOrdering) {
      options['ordering'] = this.paymentHistoryOrdering
      options['orderBy'] = this.paymentHistoryOrderingBy
    }
    return options
  }

  @action.bound
  getPaymentHistory = async () => {
    try {
      this.subscriptionHistoryLoader = true
      let filter = this.getFilterObjectForPaymentHistory()
      let options = { ...filter }
      let respone = await this.get(API_ENDPOINTS?.GET_PAYMENT_HISTORY, {
        ...options,
        pageNo: Math.max(this.paymentHistoryPageNo - 1, 0),
      })
      if (respone?.status) {
        this.subscriptionHistory = respone?.data?.paymentHistory || []
        this.paymentHistoryTotal = respone?.data?.total
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch (err) {
      this.subscriptionHistory = []
      return [false, undefined]
    } finally {
      this.subscriptionHistoryLoader = false
    }
  }

  @action.bound
  resetPaymentHistoryFilters = () => {
    this.paymentHistoryFilter = []
  }

  @action.bound
  getCurrentPlanDetails = async (loader) => {
    try {
      loader && (this.currentPlanLoader = true)
      let respone = await this.get(API_ENDPOINTS?.GET_SUBSCRIPTION_CURRENT_PLAN)
      if (respone?.status) {
        this.currentPlanDetails = respone?.data || {}
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.currentPlanLoader = false
    }
  }

  getWizad = async () => {
    try {
      const response = await this.get(API_ENDPOINTS?.GET_WIZARD_DETAILS)
      if (response?.status) {
        this.orgwizardDetails = response?.data
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  getWizadBeforeLogin = async () => {
    try {
      const response = await this.get(API_ENDPOINTS?.GET_WIZARD_DETAILS, {
        beforeLogin: true,
      })
      if (response?.status) {
        this.orgwizardDetailsforAll = response?.data
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  getDownloadTC = async () => {
    try {
      this.downloadTCLoader = true
      const response = await this.get(API_ENDPOINTS?.DOWNLOAD_TC_FILE)
      if (response?.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.downloadTCLoader = false
    }
  }

  @action.bound
  setTimeZone = async (value) => {
    try {
      const response = await this.post(
        API_ENDPOINTS?.UPDATE_ORGANIZATION_TIME_ZONE,
        {
          ...value,
        }
      )
      if (response?.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setTermsAccepted = async () => {
    try {
      const response = await this.get(API_ENDPOINTS?.SET_TERMS_ACCEPTED)
      if (response?.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setTermsAcceptedForAll = async () => {
    try {
      const response = await this.post(
        API_ENDPOINTS?.SET_TERMS_ACCEPTED_FOR_ALL,
        { termsAccepted: true }
      )
      if (response?.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setOnBoardingStep = async (values) => {
    try {
      const response = await this.post(API_ENDPOINTS?.SET_ON_BOARDING_STATUS, {
        ...values,
      })
      if (response?.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  getSubscriptionOrderSummary = async (values) => {
    try {
      this.subscriptionOrderSummaryLoader = true
      const { planId, orgId, userCount } = values || {}
      const response = await this.post(
        API_ENDPOINTS?.SUBSCRIPTION_ORDER_SUMMARY,
        {
          planId: planId,
          userCount: userCount,
        }
      )
      if (response?.status) {
        this.subscriptionOrderSummary = response?.data
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, err]
    } finally {
      this.subscriptionOrderSummaryLoader = false
    }
  }

  // Active Payment Subscription listing
  @action.bound
  setActivePaymentSubscriptionOrdering = async (value = undefined) => {
    this.activePaymentSubscriptionOrdering = value
  }

  @action.bound
  setActivePaymentSubscriptionOrderingBy = async (value = undefined) => {
    this.activePaymentSubscriptionOrderingBy = value
  }

  @action.bound
  setActiveSubscriptionSearchText = (value = '') => {
    this.activePaymentSubscriptionSearchText = value
  }

  @action.bound
  setActivePaymentSubscriptionFilter = (value = {}) => {
    this.activePaymentSubscriptionFilter = value
  }

  @action.bound
  setActivePaymentSubscriptionPageNo = (page = DEFAULT_PAGE_START) => {
    this.activePaymentSubscriptionPageNo = page
  }

  @action.bound
  getFilterObjectForActivePaymentSubscription = () => {
    let options = {}
    options.isActive = true
    let keys = Object.keys(this.activePaymentSubscriptionFilter || {})
    for (let filter of keys) {
      if (this.activePaymentSubscriptionFilter[filter]) {
        options[filter] = this.activePaymentSubscriptionFilter[filter]
      }
    }
    this.activePaymentSubscriptionSearchText &&
      (options['search'] = this.activePaymentSubscriptionSearchText)
    if (this.activePaymentSubscriptionOrdering) {
      options['ordering'] = this.activePaymentSubscriptionOrdering
      options['orderBy'] = this.activePaymentSubscriptionOrderingBy
    }
    return options
  }

  @action.bound
  getActivePaymentSubscription = async (signal) => {
    try {
      this.activePaymentSubscriptionLoader = true
      let filter = this.getFilterObjectForActivePaymentSubscription()
      let options = { ...filter }
      const response = await this.post(
        API_ENDPOINTS?.GET_ALL_ORG_PAYMENT_SUBSCRIPTION,
        {
          ...options,
          pageNo: Math.max(this.activePaymentSubscriptionPageNo - 1, 0),
        },
        signal
      )
      if (response?.status) {
        this.activePaymentSubscriptionList =
          response?.data?.paymentHistory || []
        this.activePaymentSubscriptionTotal = response.data.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.activePaymentSubscriptionLoader = false
    }
  }

  @action.bound
  getActivePaymentSubscriptionExport = async ({
    exportFileType = 'csv',
  } = {}) => {
    try {
      let options = this.getFilterObjectForActivePaymentSubscription()
      options['exportFileType'] = exportFileType
      let response = await this.post(
        API_ENDPOINTS.EXPORT_ALL_ORG_PAYMENT_SUBSCRIPTION,
        {
          ...options,
          pageNo: Math.max(this.activePaymentSubscriptionPageNo - 1, 0),
        }
      )
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resetActivePaymentSubscriptionFilters = () => {
    this.activePaymentSubscriptionFilter = {}
  }

  // End Active subscription listing
  // Start In Active subscription listing
  @action.bound
  setInActivePaymentSubscriptionOrdering = async (value = undefined) => {
    this.inActivePaymentSubscriptionOrdering = value
  }

  @action.bound
  setInActivePaymentSubscriptionOrderingBy = async (value = undefined) => {
    this.inActivePaymentSubscriptionOrderingBy = value
  }

  @action.bound
  setInActiveSubscriptionSearchText = (value = '') => {
    this.inActivePaymentSubscriptionSearchText = value
  }

  @action.bound
  setInActivePaymentSubscriptionFilter = (value = {}) => {
    this.inActivePaymentSubscriptionFilter = value
  }

  @action.bound
  setInActivePaymentSubscriptionPageNo = (page = DEFAULT_PAGE_START) => {
    this.inActivePaymentSubscriptionPageNo = page
  }

  @action.bound
  getFilterObjectForInActivePaymentSubscription = () => {
    let options = {}
    options.isActive = false
    let keys = Object.keys(this.inActivePaymentSubscriptionFilter || {})
    for (let filter of keys) {
      if (this.inActivePaymentSubscriptionFilter[filter]) {
        options[filter] = this.inActivePaymentSubscriptionFilter[filter]
      }
    }
    this.inActivePaymentSubscriptionSearchText &&
      (options['search'] = this.inActivePaymentSubscriptionSearchText)
    if (this.inActivePaymentSubscriptionOrdering) {
      options['ordering'] = this.inActivePaymentSubscriptionOrdering
      options['orderBy'] = this.inActivePaymentSubscriptionOrderingBy
    }
    return options
  }

  @action.bound
  getInActivePaymentSubscription = async (signal) => {
    try {
      this.inActivePaymentSubscriptionLoader = true
      let filter = this.getFilterObjectForInActivePaymentSubscription()
      let options = { ...filter }
      const response = await this.post(
        API_ENDPOINTS?.GET_ALL_ORG_PAYMENT_SUBSCRIPTION,
        {
          ...options,
          pageNo: Math.max(this.inActivePaymentSubscriptionPageNo - 1, 0),
        },
        signal
      )
      if (response?.status) {
        this.inActivePaymentSubscriptionList =
          response?.data?.paymentHistory || []
        this.inActivePaymentSubscriptionTotal = response.data.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.inActivePaymentSubscriptionLoader = false
    }
  }

  @action.bound
  getInActivePaymentSubscriptionExport = async ({
    exportFileType = 'csv',
  } = {}) => {
    try {
      let options = this.getFilterObjectForInActivePaymentSubscription()
      options['exportFileType'] = exportFileType
      let response = await this.post(
        API_ENDPOINTS.EXPORT_ALL_ORG_PAYMENT_SUBSCRIPTION,
        {
          ...options,
          pageNo: Math.max(this.inActivePaymentSubscriptionPageNo - 1, 0),
        }
      )
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resetInActivePaymentSubscriptionFilters = () => {
    this.inActivePaymentSubscriptionFilter = {}
  }
  // End inactive subscription lsiting

  @action.bound
  setMenualSubscription = async (values) => {
    try {
      const response = await this.post(API_ENDPOINTS?.MANUAL_SUBSCRIPTION, {
        ...values,
      })
      if (response?.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resetStore = () => {
    this.allSubscriptionDropdown = []
    this.usageByOrgId = []
    this.subPlanId = []
    this.planName = []
    this.subscriptionPlanList = []
    this.updateSubscriptionPlanLoader = false
    this.subscriptionPlanListLoader = false
    this.subscriptionKeyList = []
    this.subscriptionCancelLoading = false
    this.subscriptionCancelReqDeleteLoader = false
    this.userUpdateInPlanLoader = false

    this.generateBraintreeTokenLoader = false
    this.paymentHistoryOrdering = undefined
    this.paymentHistoryOrderingBy = undefined
    this.paymentHistorySearchText = ''
    this.paymentHistoryFilter = {}
    this.paymentHistoryPageNo = DEFAULT_PAGE_START
    this.subscriptionHistoryLoader = false
    this.subscriptionHistory = []
    this.paymentHistoryTotal = 0
    this.orgwizardDetails = []
    this.orgwizardDetailsforAll = []

    this.currentPlanDetails = {}
    this.currentPlanLoader = false
    this.isPaymentCard = false
    this.paymentConfirm = {}
    this.downloadTCLoader = false
    this.subscriptionOrderSummary = {}
    this.subscriptionOrderSummaryLoader = false
    //  Active Payment Subscription
    this.activePaymentSubscriptionOrdering = undefined
    this.activePaymentSubscriptionOrderingBy = undefined
    this.activePaymentSubscriptionSearchText = ''
    this.activePaymentSubscriptionFilter = {}
    this.activePaymentSubscriptionPageNo = DEFAULT_PAGE_START
    this.activePaymentSubscriptionLoader = false
    this.activePaymentSubscriptionList = []
    this.activePaymentSubscriptionTotal = 0
    // inActive Payment subscription
    this.inActivePaymentSubscriptionOrdering = undefined
    this.inActivePaymentSubscriptionOrderingBy = undefined
    this.inActivePaymentSubscriptionSearchText = ''
    this.inActivePaymentSubscriptionFilter = {}
    this.inActivePaymentSubscriptionPageNo = DEFAULT_PAGE_START
    this.inActivePaymentSubscriptionLoader = false
    this.inActivePaymentSubscriptionList = []
    this.inActivePaymentSubscriptionTotal = 0
  }
}
